import { SET_ADDRESS2 } from "../actionTypes";

const initialState = "";

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_ADDRESS2: {
      return action.payload;
    }
    default:
      return state;
  }
};
